import type { Dispatch, SetStateAction } from 'react';
import type { UseClientTimesheetProjectsResult } from '../../../../hooks/use-client-timesheet-projects';

/** Shared calendar + India FY — multi-select in header; invoice / charts / timesheet sync. */
export interface ClientDetailSharedPeriod {
  calendarYears: string[];
  calendarMonths: string[];
  fyYears: string[];
  fyQuarters: string[];
}

function sortYearDescStrings(arr: string[]): string[] {
  return [...new Set(arr)].sort((a, b) => Number(b) - Number(a));
}

/**
 * Maps Client Management list FilterBar state into the detail header period.
 * Calendar axis wins when any calendar year is selected (same as list `calendarActive`).
 */
export function listPageFiltersToClientDetailSharedPeriod(p: {
  calendarYears: string[];
  /** "" = all months within selected years; else "1"–"12" */
  calendarMonth: string;
  fyYears: string[];
  /** '' | 'Q1'–'Q4' | 'Full' */
  fyQuarter: string;
}): ClientDetailSharedPeriod {
  if (p.calendarYears.length > 0) {
    const months =
      String(p.calendarMonth || '').trim() === ''
        ? []
        : [String(parseInt(p.calendarMonth, 10)).padStart(2, '0')];
    return {
      calendarYears: sortYearDescStrings(p.calendarYears),
      calendarMonths: months,
      fyYears: [],
      fyQuarters: [],
    };
  }
  if (p.fyYears.length > 0) {
    const fq = String(p.fyQuarter || '').trim();
    const fyQuarters =
      fq === 'Q1' || fq === 'Q2' || fq === 'Q3' || fq === 'Q4' ? [fq] : [];
    return {
      calendarYears: [],
      calendarMonths: [],
      fyYears: sortYearDescStrings(p.fyYears),
      fyQuarters,
    };
  }
  return {
    calendarYears: [],
    calendarMonths: [],
    fyYears: [],
    fyQuarters: [],
  };
}

export interface ClientDetailPeriodBundle {
  period: ClientDetailSharedPeriod;
  setPeriod: Dispatch<SetStateAction<ClientDetailSharedPeriod>>;
  clearSharedPeriod: () => void;
  availableCalendarYears: string[];
  availableFYYears: string[];
  ts: UseClientTimesheetProjectsResult;
}
